/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityClusterEntry
 */
export interface IdentityClusterEntry {
    /**
     * 
     * @type {string}
     * @memberof IdentityClusterEntry
     */
    idType?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityClusterEntry
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof IdentityClusterEntry
     */
    confidence?: number;
    /**
     * 
     * @type {Date}
     * @memberof IdentityClusterEntry
     */
    firstSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IdentityClusterEntry
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IdentityClusterEntry
     */
    sourceSystem?: string;
}

/**
 * Check if a given object implements the IdentityClusterEntry interface.
 */
export function instanceOfIdentityClusterEntry(value: object): value is IdentityClusterEntry {
    return true;
}

export function IdentityClusterEntryFromJSON(json: any): IdentityClusterEntry {
    return IdentityClusterEntryFromJSONTyped(json, false);
}

export function IdentityClusterEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityClusterEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'idType': json['idType'] == null ? undefined : json['idType'],
        'value': json['value'] == null ? undefined : json['value'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'firstSeenAt': json['firstSeenAt'] == null ? undefined : (new Date(json['firstSeenAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
    };
}

export function IdentityClusterEntryToJSON(json: any): IdentityClusterEntry {
    return IdentityClusterEntryToJSONTyped(json, false);
}

export function IdentityClusterEntryToJSONTyped(value?: IdentityClusterEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idType': value['idType'],
        'value': value['value'],
        'confidence': value['confidence'],
        'firstSeenAt': value['firstSeenAt'] == null ? undefined : ((value['firstSeenAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
    };
}

